import { useContext } from 'react';
import clsx from 'clsx';

import renameIcon from '@atom/components/common/svgIcons/renameIcon.svg';
import { DatePicker, Icon, Switch, TextField } from '@atom/mui';
import { EventIcon } from '@atom/mui/icons';

import CreateWorkModalContext from '../CreateWorkModalContext';
import {
  isBulkQuantityValid,
  MAX_BULK_QUANTITY,
} from '../createWorkModalUtilities';

import classes from './steps.module.css';

const styles = {
  icon: {
    marginRight: '2rem',
  },
};

const BulkWorkDetailsStep = () => {
  const { draft, updateDraftField } = useContext(CreateWorkModalContext);

  const quantityInvalid = !isBulkQuantityValid(draft.quantity);

  const handleQuantityChange = (value: string) => {
    const parsed = parseInt(value, 10);
    updateDraftField('quantity', Number.isNaN(parsed) ? null : parsed);
  };

  return (
    <>
      <div className={classes.detailsHeader}>Work Details</div>
      <div className={classes.detailsContent}>
        <div className={clsx(classes.detailsRow, classes.name)}>
          <Icon style={styles.icon}>
            <img src={renameIcon} />
          </Icon>
          <TextField
            required
            fullWidth
            type="number"
            id="workOrderQuantity"
            label="Quantity"
            value={draft.quantity ?? ''}
            onChange={event => handleQuantityChange(event.target.value)}
            error={quantityInvalid}
            slotProps={{ htmlInput: { min: 1, max: MAX_BULK_QUANTITY } }}
            data-cy="createWorkModalQuantityInput"
          />
        </div>
        <div className={clsx(classes.detailsRow, classes.dueDate)}>
          <Icon icon={EventIcon} style={styles.icon} />
          <DatePicker
            label="Due Date"
            value={draft.dueDate}
            onChange={date => updateDraftField('dueDate', date || null)}
            data-cy="createWorkModalDueDateInput"
          />
        </div>
        <div className={clsx(classes.detailsRow, classes.location)}>
          <Switch
            checked={draft.isLocationBased}
            onChange={() =>
              updateDraftField('isLocationBased', !draft.isLocationBased)
            }
            name="isLocationBased"
            label="Location"
            data-cy="createWorkModalLocationSwitch"
          />
        </div>
      </div>
    </>
  );
};

export default BulkWorkDetailsStep;
